export class CpCode {
  clientId;
  cpCode;
  id;

  constructor(obj?: CpCode) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/vocabularies/cp-codes/cp-codes.model.ts